<template>
    <nav v-if="items.length" class="manual-child-pages" :aria-label="lang('manual::manual.subpages')">
        <p class="manual-child-pages__heading">{{ lang('manual::manual.subpages') }}</p>
        <ul class="manual-child-pages__list">
            <li v-for="item in items" :key="item.uid">
                <button type="button" class="manual-child-pages__item" @click="$emit('select', item.uid)">
                    <span aria-hidden="true">→</span>
                    {{ item.title }}
                </button>
            </li>
        </ul>
    </nav>
</template>

<script setup lang="ts">
import { lang } from '@/lang/composable';

defineProps<{ items: Array<{ uid: string; title: string }> }>();
defineEmits<{ select: [uid: string] }>();
</script>

<style scoped>
.manual-child-pages {
    margin-top: 1.5rem;
}
.manual-child-pages__heading {
    font-size: 0.75rem;
    opacity: 0.6;
    margin-bottom: 0.375rem;
}
.manual-child-pages__list {
    list-style: none;
    margin: 0;
    padding: 0;
}
.manual-child-pages__item {
    display: block;
    text-align: left;
    padding: 0.25rem 0;
}
.manual-child-pages__item:hover {
    text-decoration: underline;
}
</style>
